/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineBotExamLangGridItemViewModel } from "../types/ClassroomDisciplineBotExamLangGridItemViewModel.ts";
import { eBotExamTranslateStatusSchema } from "./eBotExamTranslateStatusSchema.ts";

export const classroomDisciplineBotExamLangGridItemViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do registro de idioma da prova bot."),
  ),
  classroomDisciplineBotExamId: z.optional(
    z
      .number()
      .int()
      .describe("ID da prova bot principal à qual este idioma pertence."),
  ),
  cultureInfo: z
    .string()
    .describe("Nome do idioma (ex: Inglês (Estados Unidos)). Opcional.")
    .nullish(),
  cultureInfoCode: z
    .string()
    .describe("Código de cultura do idioma (ex: en-US). Opcional.")
    .nullish(),
  title: z
    .string()
    .describe("Título da prova bot neste idioma. Opcional.")
    .nullish(),
  instruction: z
    .string()
    .describe("Instrução geral da prova bot neste idioma. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se este idioma está ativo.")),
  status: z
    .string()
    .describe(
      "Status de tradução/revisão deste idioma. Enum EBotExamTranslateStatus: `1` = PendingReview, `2` = Reviewed.",
    )
    .nullish(),
  statusEnum: z.optional(
    z
      .lazy(() => eBotExamTranslateStatusSchema)
      .describe("1 = PendingReview | 2 = Reviewed | "),
  ),
}) as unknown as ToZod<ClassroomDisciplineBotExamLangGridItemViewModel>;
